<!--乐刷、云闪付、微信投诉申诉表单-->
<template>
  <div class="otherForm">
    <el-dialog title="申诉表单" :visible.sync="dialogVisible" width="1020px" @close="$emit('update:visible', dialogVisible)">
      <h3>商户信息</h3>
      <div v-loading="loading">
        <div class="marginLeft">
          <p>
            商户简称：{{ messageForm.fMerchantName }}&nbsp;&nbsp;&nbsp;
            风险来源：{{ fRiskSourceStr }}&nbsp;&nbsp;&nbsp;
            工单号：{{ messageForm.fTicketNumber }}&nbsp;&nbsp;&nbsp;
            处理状态：
            <span v-if="messageForm.auditStatus === 1" class="red">待提交</span>
            <span v-if="messageForm.auditStatus === 2">审核中</span>
            <span v-if="messageForm.auditStatus === 3" class="red">审核未通过</span>
            <span v-if="messageForm.auditStatus === 4" class="green">审核通过</span>
            <span v-if="messageForm.auditStatus === 5" class="red">审核终止</span>&nbsp;&nbsp;
          </p>
          <p>已审次数：{{ messageForm.fMtlVerifyTimes }} &nbsp;&nbsp;&nbsp;<span class="blue">注：每个工单有5次申诉机会，若第五次仍审核不通过，则终止审核。</span></p>
        </div>
        <h3>填写申诉资料</h3>
        <p class="smallFont">请保证资质照片的匹配性，证照齐全且真实有效。</p>
        <el-form ref="appealForm" :model="appealForm" :data="appealForm" label-position="top" :rules="appeal_rules">
          <h4><font class="red">*</font>1、视频：<span class="red" v-if="verifyFailed && disabledItem.videoUrl">（资料未通过审核，请提交正确资料）</span></h4>
          <el-row>
            <el-form-item>
              <!-- prop="videoUrl" 视频或补充材料二选一 -->
              <p class="formTips">要求：一个不间断视频,视频时长不低于45秒<br>
                视频内容包含：<br>
                1)每个收款码牌1米左右远距离的视频<br>
                2)商户门头(含门牌号)、营业场所内部、交易场景(服务对象,货物,销售人员在场,收银台等)、营业执照(经营许可证)<br>
                {{requestForm.appealInfoType === 1 ? '备注：个体工商商户或小微商户须提供视频，企业商户无法提供视频的，可提供企业的门头照、营业场所内部照、收银台照片，营业执照照片，并加盖公章' : ''}}
                <!-- 备注：个体工商商户或小微商户须提供视频，企业商户无法提供视频的，可提供企业的门头照、营业场所内部照、收银台照片，营业执照照片，并加盖公章 -->
              </p>
              <div class="uploadZone">
                <upload-video-oss
                  description="上传视频"
                  :value="appealForm.videoUrl"
                  v-model="appealForm.videoUrl"
                  :disabled="verifyFailed && !disabledItem.videoUrl"
                  valueName="videoUrl"
                  @uploaded="uploadSuccess"></upload-video-oss>
                <upload-files valueName="nonVideoMaterials" @success="uploadFileSuccess" @deleteFile="deleteExtendFile" :makeUpFileList="appealForm.nonVideoMaterials" v-if="requestForm.appealInfoType === 1"></upload-files>
              </div>
              <span v-if="firstPartRequird" class="red">{{requestForm.appealInfoType === 1 ? '请上传视频' : '请上传视频或添加补充材料'}}</span>
            </el-form-item>
          </el-row>
          <h4><font class="red">*</font>2、身份证、银行卡：<span class="red" v-if="verifyFailed && disabledItem.handheldImg || verifyFailed && disabledItem.bankCardFront || verifyFailed && disabledItem.bankCardFrontImg">（资料未通过审核，请提交正确资料）</span></h4>
          <p class="smallFont">请提交jpg、jpeg或png格式的图片，且单张需小于1MB。</p>
          <el-row>
            <el-col :span="12">
              <el-form-item label="" prop="handheldImg">
                <uploadImg
                  :value="appealForm.handheldImg"
                  label="收款人手持身份证正面（头像面）照片"
                  :required="true"
                  v-model="appealForm.handheldImg"
                  valueName="handheldImg"
                  :readonly="verifyFailed && !disabledItem.handheldImg"
                  :exampleImg="id_eg"
                  @success="uploadSuccess"></uploadImg>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="bankCardFront">
                <uploadImg
                  :value="appealForm.bankCardFront"
                  label="收款人手持银行卡照片"
                  :required="true"
                  v-model="appealForm.bankCardFront"
                  valueName="bankCardFront"
                  :readonly="verifyFailed && !disabledItem.bankCardFront && !disabledItem.bankCardFrontImg"
                  :exampleImg="card_eg"
                  @success="uploadSuccess"></uploadImg>
              </el-form-item>
            </el-col>
          </el-row>
          <h4><font class="red" v-if="evidenceRequired">*</font>3、交易小票、机打购物清单：<span class="red" v-if="verifyFailed && disabledItem.txnInfoModels">（资料未通过审核，请提交正确资料）</span></h4>
          <!-- <p class="smallFont">请提供以下3笔订单对应的小票、或机打购物清单。要求：需清晰展示 订单号--交易金额--交易时间。</p> -->
          <p class="formTips" v-if="requestForm.appealInfoType === 1">提供指定3笔交易的交易小票或机打购物清单（不受理手工填写的单据）；如无法提供，可分情况按如下方式提供：<br>
            1)有收银机系统的商户可提供系统交易截图<br>
            2)没有收银系统的商户可提供收银工具照片<br>
            3)其他佐证材料，包括不限于：产品价目表、产品介绍（营销手册、营销模式）、产品相关的协议合同、发票/增值税发票（以上所有的合同、协议及单据都需要盖公章）
          </p>
          <p class="formTips" v-else>提供指定3笔交易的交易小票或机打购物清单（不受理手工填写的单据）；如无法提供，请在下方4处上传佐证资料<br>
            其他佐证材料，包括不限于：产品价目表、产品介绍（营销手册、营销模式）、产品相关的协议合同、发票/增值税发票（以上所有的合同、协议及单据都需要盖公章）
          </p>
          <el-row class="evidenceDiv">
            <el-col :span="12">
              <el-form-item
                prop="evidenceImg1"
                :rules="[{
                  required: evidenceRequired,
                  message:'请上传第1笔订单对应的小票、或机打购物清单',
                  trigger: 'change'
                }]">
                <uploadImg
                  :value="appealForm.evidenceImg1"
                  label="第1笔小票"
                  :required="evidenceRequired"
                  v-model="appealForm.evidenceImg1"
                  valueName="evidenceImg1"
                  :readonly="verifyFailed && !disabledItem.txnInfoModels"
                  :exampleImg="shop_eg"
                  @success="uploadSuccess"></uploadImg>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <p class="orderInfo">
                订单号：{{ appealForm.orderId1 }}<br>
                交易金额：{{ appealForm.txnAmt1?parseFloat(appealForm.txnAmt1/100).toFixed(2)+'元':'' }}<br>
                交易时间：{{ appealForm.txnTime1 }}
              </p>
            </el-col>
          </el-row>
          <el-row class="evidenceDiv">
            <el-col :span="12">
              <el-form-item
                prop="evidenceImg2"
                :rules="[{
                  required: evidenceRequired,
                  message:'请上传第2笔订单对应的小票、或机打购物清单',
                  trigger: 'change'
                }]">
                <uploadImg
                  label="第2笔小票"
                  :required="evidenceRequired"
                  v-model="appealForm.evidenceImg2"
                  valueName="evidenceImg2"
                  :readonly="verifyFailed && !disabledItem.txnInfoModels"
                  @success="uploadSuccess"></uploadImg>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <p class="orderInfo">
                订单号：{{ appealForm.orderId2 }}<br>
                交易金额：{{ appealForm.txnAmt2?parseFloat(appealForm.txnAmt2/100).toFixed(2)+'元':'' }}<br>
                交易时间：{{ appealForm.txnTime2 }}
              </p>
            </el-col>
          </el-row>
          <el-row class="evidenceDiv">
            <el-col :span="12">
              <el-form-item
                prop="evidenceImg3"
                :rules="[{
                  required: evidenceRequired,
                  message:'请上传第3笔订单对应的小票、或机打购物清单',
                  trigger: 'change'
                }]">
                <uploadImg
                  label="第3笔小票"
                  :required="evidenceRequired"
                  v-model="appealForm.evidenceImg3"
                  valueName="evidenceImg3"
                  :readonly="verifyFailed && !disabledItem.txnInfoModels"
                  @success="uploadSuccess"></uploadImg>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <p class="orderInfo">
                订单号：{{ appealForm.orderId3 }}<br>
                交易金额：{{ appealForm.txnAmt3?parseFloat(appealForm.txnAmt3/100).toFixed(2)+'元':'' }}<br>
                交易时间：{{ appealForm.txnTime3 }}
              </p>
            </el-col>
          </el-row>
          <el-row class="evidenceDiv" v-if="requestForm.appealInfoType === 1">
            <el-col :span="12">
              <el-form-item>
                <span>其他佐证材料</span>
                <upload-files
                  description="其他佐证材料"
                  valueName="nonOrderEvidence"
                  @success="uploadEvidSuccess"
                  :makeUpFileList="appealForm.nonOrderEvidence"
                  @deleteFile="deleteEvidenceFile"></upload-files>
              </el-form-item>
            </el-col>
          </el-row>
          <h4>4、其他有助于审核的材料照片{{requestForm.appealInfoType === 1 ? '' : '（若无3所需资料，请在此处提交佐证资料）'}}：<span class="red" v-if="verifyFailed && disabledItem.auxiliaryInfo">（资料未通过审核，请提交正确资料）</span></h4>
          <el-form-item>
            <multi-upload
              :value="appealForm.auxiliaryInfo"
              valueName="auxiliaryInfo"
              :limit="6"
              :disabled="verifyFailed && !disabledItem.auxiliaryInfo"
              @init-upload="initMultiUpload"
              @uploaded="multiUploaded"
              @delete="multiDelete"></multi-upload>
          </el-form-item>
          <!--                    <h4>5、其他材料：<span class="red" v-if="verifyFailed && disabledItem.otherInfo">（资料未通过审核，请提交正确资料）</span></h4>-->
          <!--                    <p class="smallFont">请上传您认为其他有助于帮助我们审核的材料照片，最多上传2张照片。</p>-->
          <!--                    <el-form-item>-->
          <!--                        <multi-upload :value="appealForm.otherInfo" valueName="otherInfo" :disabled="verifyFailed && !disabledItem.otherInfo" :limit="2" @init-upload="initMultiUpload" @uploaded="multiUploaded" @delete="multiDelete"></multi-upload>-->
          <!--                    </el-form-item>-->
          <el-form-item>
            <el-button type="primary" @click="submit" :loading="submitLoading" v-if="messageForm.auditStatus === 1 || messageForm.auditStatus === 3">立即提交</el-button>
            <el-button v-else :readonly="messageForm.auditStatus !== 1 && messageForm.auditStatus !== 3">已提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import uploadImg from '@/components/upload/uploadImg'
import multiUpload from '@/components/upload/multiUpload'
import uploadVideoOss from '@/components/upload/uploadVideoOss'
import uploadFiles from '@/components/upload/uploadFiles'
import { riskTicketsDetail, riskTicketsFormDetails, checkNoPassItem, commitRiskTicket } from '@/api/risk'
import { parseAuditStatus } from '@/utils/parseData'
export default {
  name: 'OtherForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    requestForm: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    uploadImg,
    multiUpload,
    uploadVideoOss,
    uploadFiles
  },
  data () {
    return {
      dialogVisible: false,
      firstPartRequird: false, // 视频或补充材料都没上传
      // 详情信息
      messageForm: {
        fMerchantName: '',
        fTicketNumber: '',
        fMtlVerifyStatus: '',
        fRiskSource: '',
        fMtlVerifyTimes: '',
        auditStatus: ''
      },
      // 提交表单
      appealForm: {
        videoUrl: '',
        handheldImg: '',
        bankCardFront: '',
        orderId1: '',
        txnAmt1: '',
        txnTime1: '',
        evidenceImg1: '',
        orderId2: '',
        txnAmt2: '',
        txnTime2: '',
        evidenceImg2: '',
        orderId3: '',
        txnAmt3: '',
        txnTime3: '',
        evidenceImg3: '',
        auxiliaryInfo: '',
        // otherInfo:''
        nonVideoMaterials: [], // 补充资料
        nonOrderEvidence: [], // 佐证资料
        riskSource: '',
        FMerchantTxnType: ''
      },
      appeal_rules: {
        videoUrl: [{
          required: true,
          message: '请上传视频',
          trigger: 'change'
        }],
        handheldImg: [{
          required: true,
          message: '请上传收款人手持身份证正面（头像面）照片',
          trigger: 'change'
        }],
        bankCardFront: [{
          required: true,
          message: '请上传收款人手持银行卡照片',
          trigger: 'change'
        }],
        evidenceImg1: [{
          required: true,
          message: '请上传第1笔订单对应的小票、或机打购物清单',
          trigger: 'change'
        }],
        evidenceImg2: [{
          required: true,
          message: '请上传第2笔订单对应的小票、或机打购物清单',
          trigger: 'change'
        }],
        evidenceImg3: [{
          required: true,
          message: '请上传第3笔订单对应的小票、或机打购物清单',
          trigger: 'change'
        }]
      },
      disabledItem: {
        videoUrl: false,
        handheldImg: false,
        bankCardFront: false,
        txnInfoModels: false,
        auxiliaryInfo: false
        // otherInfo: false
      }, // 审核失败项
      verifyFailed: false, // 是否审核失败
      submitLoading: false,
      loading: false,
      evidenceRequired: true, // 小票是否需要必传
      id_eg: require('../../../../../static/images/id_eg.jpg'),
      card_eg: require('../../../../../static/images/card_eg.jpg'),
      shop_eg: require('../../../../../static/images/shop_eg.jpg')
    }
  },
  computed: {
    fRiskSourceStr () {
      switch (this.messageForm.fRiskSource) {
        case 1: {
          return '微信投诉'
        }
        case 2: {
          return '微信违规'
        }
        case 3: {
          return '支付宝违规'
        }
        case 4: {
          return '云闪付'
        }
        case 6: {
          return '支付宝告警'
        }
        default: {
          return '乐刷'
        }
      }
    }
  },
  watch: {
    visible (value) {
      this.dialogVisible = value
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      this.loading = true
      this.dialogVisible = this.visible
      await this.getDetails()
      await this.getDefaultData()
      // 审核不通过查询不合格项
      await this.checkStatus()
      this.loading = false
    },
    async getDetails () {
      var data = {
        ticketNumber: this.requestForm.ticketNumber
      }
      var that = this
      data = qs.stringify(data)
      return new Promise((resolve, reject) => {
        riskTicketsDetail(data).then((data) => {
          if (parseInt(data.error_code) !== 0) {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            resolve(false)
          } else {
            //    赋值给agentForm
            that.messageForm.fMerchantName = data.data.fMerchantName
            that.messageForm.fTicketNumber = data.data.fTicketNumber
            that.messageForm.fMtlVerifyStatus = data.data.fMtlVerifyStatus
            that.messageForm.auditStatus = parseAuditStatus(data.data.fTicketStatus, data.data.fMtlVerifyStatus)
            that.messageForm.fRiskSource = data.data.fRiskSource
            that.messageForm.fMtlVerifyTimes = data.data.fMtlVerifyTimes
            that.messageForm.fMerchantId = data.data.fMerchantId
            that.appealForm.FMerchantTxnType = data.data.fMerchantTxnType
            that.appealForm.riskSource = that.messageForm.fRiskSource
            if (that.messageForm.auditStatus === 3) {
              that.verifyFailed = true
            }
            resolve()
          }
        })
      })
    },
    /**
             * @description 初始化
             */
    async getDefaultData () {
      var data = this.requestForm
      var that = this
      data = qs.stringify(data)
      riskTicketsFormDetails(data).then((data) => {
        if (parseInt(data.error_code) !== 0) {
        } else {
          // if (data.data.scanRealMrtUnionPayMaterial && data.data.scanRealMrtUnionPayMaterial.txnInfoModels.length > 0) {
          //   const info = data.data.scanRealMrtUnionPayMaterial
          //   that.evaluation(info)
          //   if (info.txnInfoModels.length === 0) {
          //     that.evidenceRequired = false
          //   }
          //   info.txnInfoModels.map(function (item, index) {
          //     const key = index + 1
          //     that.appealForm['orderId' + key] = item.orderId
          //     that.appealForm['txnAmt' + key] = item.txnAmt
          //     that.appealForm['txnTime' + key] = item.txnTime
          //     that.appealForm['evidenceImg' + key] = item.evidenceImg
          //   })
          //   if (info.videoUrl === ' ') {
          //     that.appealForm.videoUrl = ''
          //   }
          //   // 对补充资料 / 其他佐证材料赋值
          //   if (info.nonVideoMaterials && info.nonVideoMaterials.length > 0) {
          //     that.appealForm.nonVideoMaterials = info.nonVideoMaterials.map(item => {
          //       return {
          //         name: item.name,
          //         path: item.uri
          //       }
          //     })
          //   }
          //   if (info.nonOrderEvidence && info.nonOrderEvidence.length > 0) {
          //     that.appealForm.nonOrderEvidence = info.nonOrderEvidence.map(item => {
          //       return {
          //         name: item.name,
          //         path: item.uri
          //       }
          //     })
          //   }
          // }
          const info = data.data
          // 传参 字符串转对象
          info.txnInfoModels = info.txnInfoModels ? JSON.parse(info.txnInfoModels) : []
          info.nonVideoMaterials = info.nonVideoMaterials ? JSON.parse(info.nonVideoMaterials) : []
          info.nonOrderEvidence = info.nonOrderEvidence ? JSON.parse(info.nonOrderEvidence) : []
          info.auxiliaryInfo = info.auxiliaryInfo ? JSON.parse(info.auxiliaryInfo) : ''
          info.bankCardFront = info.bankCardFront || info.bankCardFrontImg
          that.evaluation(info)
          if (info.txnInfoModels.length === 0) {
            that.evidenceRequired = false
          }
          info.txnInfoModels.map(function (item, index) {
            const key = index + 1
            that.appealForm['orderId' + key] = item.orderId
            that.appealForm['txnAmt' + key] = item.txnAmt
            that.appealForm['txnTime' + key] = item.txnTime
            that.appealForm['evidenceImg' + key] = item.evidenceImg
          })
          if (info.videoUrl === ' ') {
            that.appealForm.videoUrl = ''
          }
          // 对补充资料 / 其他佐证材料赋值
          if (info.nonVideoMaterials && info.nonVideoMaterials.length > 0) {
            that.appealForm.nonVideoMaterials = info.nonVideoMaterials.map(item => {
              return {
                name: item.name,
                path: item.uri
              }
            })
          }
          if (info.nonOrderEvidence && info.nonOrderEvidence.length > 0) {
            that.appealForm.nonOrderEvidence = info.nonOrderEvidence.map(item => {
              return {
                name: item.name,
                path: item.uri
              }
            })
          }
        }
      })
    },
    async checkStatus () {
      if (this.messageForm.auditStatus !== 3) {
        return false
      }
      var data = {
        ticketNumber: this.messageForm.fTicketNumber,
        merchantId: this.messageForm.fMerchantId,
        appealInfoType: this.requestForm.appealInfoType
      }
      var that = this
      data = qs.stringify(data)
      return new Promise(function (resolve, reject) {
        checkNoPassItem(data).then((data) => {
          if (parseInt(data.error_code) !== 0) {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            resolve(false)
          } else {
            if (data.data.operationCheckResult.length > 0) {
              // data.data.operationCheckResult.map(function (item) {
              //     let noPassList = item.nonCompliantUnionpay;
              //     noPassList.map(function (item2) {
              //         that.disabledItem[item2] = true;
              //     });
              // });
              let noPassList = []
              if (that.requestForm.appealInfoType === 1) {
                noPassList = data.data.operationCheckResult[0].nonCompliantUnionpay
              } else {
                noPassList = data.data.operationCheckResult[0].nonCompliantChannelTrue.concat(data.data.operationCheckResult[0].nonCompliantChannelFalse)
                console.log(noPassList)
              }
              noPassList.map(function (item2) {
                that.disabledItem[item2] = true
              })
            }
            if (data.data.riskCheckResult.length > 0) {
              // data.data.riskCheckResult.map(function (item) {
              //     let noPassList2 = item.nonCompliantUnionpay;
              //     noPassList2.map(function (item2) {
              //         that.disabledItem[item2] = true;
              //     });
              // })
              let noPassList2 = []
              if (that.requestForm.appealInfoType === 1) {
                noPassList2 = data.data.riskCheckResult[0].nonCompliantUnionpay
              } else {
                noPassList2 = data.data.riskCheckResult[0].nonCompliantChannelTrue.concat(data.data.riskCheckResult[0].nonCompliantChannelFalse)
              }
              noPassList2.map(function (item2) {
                that.disabledItem[item2] = true
              })
            }
            resolve()
          }
        })
      })
    },
    /**
             * @description 图片、视频上传成功的回调
             */
    uploadSuccess (data) {
      var name = data.valueName
      this.appealForm[name] = data.path
    },
    /**
             * @description 补充资料上传成功的回调
             */
    uploadFileSuccess (data) {
      this.appealForm.nonVideoMaterials.push(data)
      const obj = {}
      const objres = this.appealForm.nonVideoMaterials.reduce((item, next) => {
        // eslint-disable-next-line no-unused-expressions
        obj[next.name] ? '' : obj[next.name] = true && item.push(next)
        return item
      }, [])
      this.appealForm.nonVideoMaterials = [...objres]
    },
    /**
             * @description 删除补充资料
             */
    deleteExtendFile (data) {
      this.appealForm.nonVideoMaterials = this.appealForm.nonVideoMaterials.filter(item => item.name !== data.name)
    },
    /**
             * @description 其他佐证资料上传成功的回调
             */
    uploadEvidSuccess (data) {
      this.appealForm.nonOrderEvidence.push(data)
      const obj = {}
      const objres = this.appealForm.nonOrderEvidence.reduce((item, next) => {
        // eslint-disable-next-line no-unused-expressions
        obj[next.name] ? '' : obj[next.name] = true && item.push(next)
        return item
      }, [])
      this.appealForm.nonOrderEvidence = [...objres]
    },
    /**
             * @description 删除佐证资料
             */
    deleteEvidenceFile (data) {
      this.appealForm.nonOrderEvidence = this.appealForm.nonOrderEvidence.filter(item => item.name !== data.name)
    },
    initMultiUpload (data) {
      var that = this
      if (that.appealForm[data.valueName]) {
        that.appealForm[data.valueName] = that.appealForm[data.valueName].replace(data.oldPath, data.path)
      }
    },
    // 批量上传成功回调
    multiUploaded (data) {
      var that = this
      if (that.appealForm[data.valueName] === '') {
        that.appealForm[data.valueName] += data.path
      } else {
        that.appealForm[data.valueName] += ',' + data.path
      }
    },
    // 批量上传删除某一张回调
    multiDelete (data) {
      if (this.appealForm[data.valueName].indexOf(',' + data.path) >= 0) {
        this.appealForm[data.valueName] = this.appealForm[data.valueName].replace(',' + data.path, '')
      } else {
        this.appealForm[data.valueName] = this.appealForm[data.valueName].replace(data.path, '')
      }
      if (this.appealForm[data.valueName].indexOf(',') === 0) {
        this.appealForm[data.valueName] = this.appealForm[data.valueName].substring(1)
      }
    },
    submit () {
      let result
      if (!this.appealForm.videoUrl && this.appealForm.nonVideoMaterials.length < 1) {
        this.firstPartRequird = true
      } else {
        this.firstPartRequird = false
      }
      this.$refs.appealForm.validate((valid) => {
        result = valid
        if (!valid || this.firstPartRequird) {
          this.$message({
            message: '申诉资料信息有误或不完整，请完善相关信息',
            type: 'warning'
          })
        }
      })
      if (!result && this.submitLoading) {
        return false
      }
      if (this.firstPartRequird) {
        return false
      }
      this.submitLoading = true
      // 只保留name及path参数(uri)
      this.appealForm.nonVideoMaterials = this.appealForm.nonVideoMaterials.map(item => {
        return {
          name: item.name,
          uri: item.path
        }
      })
      this.appealForm.nonOrderEvidence = this.appealForm.nonOrderEvidence.map(item => {
        return {
          name: item.name,
          uri: item.path
        }
      })
      var data = Object.assign({}, this.appealForm, this.requestForm)
      data.nonVideoMaterials = JSON.stringify(data.nonVideoMaterials)
      data.nonOrderEvidence = JSON.stringify(data.nonOrderEvidence)
      data = qs.stringify(data)
      commitRiskTicket(data).then((data) => {
        this.submitLoading = false
        if (parseInt(data.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
        } else {
          this.$message({
            showClose: true,
            message: data.error_msg,
            type: 'success'
          })
          this.$emit('update:visible', false)
          this.$emit('submit', '')
        }
      }).catch(() => {
        this.submitLoading = false
      })
    },
    //    对象赋值
    evaluation (data) {
      for (const item in data) {
        if (this.appealForm[item] !== undefined) {
          if (typeof data[item] === 'object' && typeof this.appealForm[item] === 'string') {
            this.appealForm[item] = data[item].join(',')
          } else {
            this.appealForm[item] = data[item]
          }
        }
      }
    }
  }
}
</script>

<style scoped>
    .otherForm h3{
        margin-top: 30px;
    }
    p{
      margin: 14px;
    }
    .marginLeft{
        margin-left: 20px;
    }
    .blue{
        color:#409EFF;
    }
    .red{
        color:#F56C6C;
        display: inline-block;
    }
    .smallFont{
        font-size: 12px;
    }
    .formTips{
        line-height: 25px;
        margin-top: 0;
    }
    .green{
        color: #77d580;
    }
    .marginBtm{
        margin-bottom: 20px;
    }
    .orderInfo{
        line-height: 30px;
    }
    .el-form-item{
        margin-bottom: 30px;
    }
    .evidenceDiv{
        margin-bottom: 10px;
    }
    .uploadZone {
        display:flex;
        height:200px;
    }
</style>
